module.exports = __webpack_public_path__ + "img/bubble.a3f2d80d.jpg";